import React from 'react';
import ReactDOM from 'react-dom/client';
// import '../public/styles.css';
import {App} from './components';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);